import React, { useState } from "react";
import moment from "moment";
import { useArchiveDebtorsMutation, useLazyAgedDebtorsQuery } from "../../../services/headofficeadmin";


const useArchiveDebtors = (theArchiveDate,reloadDebtorsFromDate,reloadDebtorsToDate) => {
    //const [actualFinRequest, setActualFinRequest] = useState(null);
    //const request = {archiveDate: moment(new Date('2024-06-30')).format("YYYY-MM-DD"),loadFromDate: moment(new Date('2023-06-01')).format("YYYY-MM-DD")};
    //const fromDate = request.loadFromDate;
    
    //const theRequest = request;
    //console.log('theRequest- ',theRequest.archiveDate,' - ',theRequest.loadFromDate);

    //const [theArchiveRequest, setTheArchiveRequest] = useState({archiveDate:theArchiveDate});
    //const [theLoadFromDate, setTheLoadFromDate] = useState(null);
    //const [theToDate, setTheToDate] = useState(null);

    //console.log('archiveRequestInHook',request);
    //const archiveDebtors = null;
    //console.log('hook-fromDate',fromDate);
    //setTheArchiveRequest({archiveDate:archiveRequest.archiveDate});
    //console.log('setArchiveRequest',theArchiveRequest);
    //setTheLoadFromDate(archiveRequest.loadFromDate);
    //console.log('setLoadFromDate',theLoadFromDate);

    //React.useEffect(() => {
        //if(theArchiveDate !== null){
            //console.log('fromHookTheArchiveRequest',theArchiveRequest);
            //setTheArchiveRequest({archiveDate:theArchiveDate});
            ////console.log('setArchiveRequest',archiveRequest.archiveDate);
            ////setTheToDate(archiveRequest.archiveDate);
            ////setTheLoadFromDate(archiveRequest.loadFromDate);
            ////console.log('setLoadFromDate',archiveRequest.loadFromDate);
        //}    
    //}, [theArchiveDate]);

    //const [query, queryResult] = useLazyAgedDebtorsQuery({fromDate:theLoadFromDate ,toDate:theToDate});
    
    const [createTrigger] = useArchiveDebtorsMutation();
    
    //console.log('in archive hook passed reloadDebtorsFromDate', reloadDebtorsFromDate);
    //console.log('in archive hook passed reloadDebtorsToDate', reloadDebtorsToDate);

    const archiveDebtors = (theArchiveDate,reloadDebtorsFromDate,reloadDebtorsToDate) => {
        return new Promise((resolve, reject) => {
            //return createTrigger({request})
            //return createTrigger({archiveDate:moment(new Date(request.archiveDate)).format("YYYY-MM-DD"),loadFromDate:moment(new Date(request.loadFromDate)).format("YYYY-MM-DD")}) 
            //return createTrigger({ archiveDate: moment(new Date('2024-06-30')).format("YYYY-MM-DD"),loadFromDate: moment(new Date('2023-06-01')).format("YYYY-MM-DD") })
            return createTrigger({archiveDate:theArchiveDate, reloadDebtorsFromDate, reloadDebtorsToDate})

                .unwrap()
                .then(
                    r => resolve(r),
                    e => reject(e)
                );
        });
    };

    return {
        archiveDebtors
    }

};

export default useArchiveDebtors;